import { Link } from 'react-router-dom';
import Loader from '../Loader';
import { ITask } from '../../resources/interfaces';
import useRoute from '../../hooks/routesHook';
import moment from 'moment';
import { GoTasklist } from 'react-icons/go';
import { getNumberOfWordsFromString } from '../../utils/miscFunctions';
import TabNavItem from '../tabs/TabNavItem';
import { useState } from 'react';
import TabContent from '../tabs/TabContent';
import useUserAccount from '../../hooks/userAccountHook';

type TaskListCardProps = {
  title: string;
  tasks?: ITask[];
  me?:any;
  onclick?: (taskId: string) => void;
};

const TaskListCard = ({ title, tasks, me, onclick }: TaskListCardProps) => {
  const { getDashboardBase } = useRoute(); 
  const { user } = useUserAccount();
  const defaultTab = user.isOwner() ? 'Mine' : 'All'
  const [activeTab, setActiveTab] = useState<string>(defaultTab)
  
  
  const myTask = tasks?.filter((task)=>
    task?.assignedTo?.id === user?.id
  ) 
  
  return (
    <div className="">
      <div className="mt-5 min-h-52 px-3">
        <div className='flex justify-between mb-3'>
          <div className='flex gap-2'>
            <h2 className="text-[16px]">{title}</h2>
            {!user.isOwner() && <span className="px-1.5 text-white text-sm rounded-full bg-red-600">
              {tasks ? tasks?.length : 0}
            </span>}
          </div>
         
          <div>
            <Link
              to={`${getDashboardBase()}/tasks`}
              className="hover:underline underline-offset-2 text-[16px]">
              View all
            </Link>
          </div>
        </div>
        <div className="flex items-center justify-between mb-3 ">
          <div className="flex gap-6 ">
          {user.isOwner() && (
              <div className="flex items-center ">
                <TabNavItem
                  id="Mine"
                  title="Mine"
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                  classes="px-3 text-[14px]"
                />
                <span className="px-1.5 text-white text-sm rounded-full bg-red-600">
                  {myTask?.length ? myTask?.length : 0}
                </span>
              </div> )}
              {user.isOwner() && <div className="flex items-center ">
                <TabNavItem
                  id="All"
                  title="All"
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                  classes="px-3 text-[14px]"
                />
                <span className="px-1.5 text-white text-sm rounded-full bg-red-600">
                  {tasks ? tasks?.length : 0}
                </span>
              </div> }
          </div>

        </div>
        {!tasks ? (
          <div className="min-h-52 flex justify-center items-center">
            <Loader size='sm'/>
          </div>
        ) : (
          <TabContent id={activeTab} activeTab={activeTab}>
            <div className="space-y-3 overflow-y-auto w-full md:w-full  min-h-52  max-h-52">
              {activeTab == 'All'
                ? (tasks.length >0 ? tasks.reverse().map((task: ITask, index: number) => {
                    return (
                      <div key={index} className="flex items-center gap-2 ">
                        <div className="flex justify-center items-center h-10 w-10 rounded-full bg-blue-200">
                          <GoTasklist className="h-5 w-5" />
                        </div>

                        <div className="">
                          <span
                            onClick={() => onclick?.(task.id)}
                            className="text-ellipsis text-[13px] cursor-pointer block">
                            {getNumberOfWordsFromString(task.name, 5)}
                          </span>
                          <span className="text-gray-600 text-xs block">
                            {moment(task.dueOn).calendar()}
                          </span>
                        </div>
                      </div>
                    );
                  }) : <div className='flex items-center justify-center text-sm text-gray-400'>No Task Found</div> )
                : (myTask?.length && myTask?.length > 0 ? tasks
                    .filter(
                      (task) =>
                        task?.assignedTo?.id === user?.id
                    )
                    .reverse()
                    .map((task: ITask, index: number) => {
                      return (
                        <div key={index} className="flex items-center gap-2 ">
                          <div className="flex justify-center items-center h-10 w-10 rounded-full bg-blue-200">
                            <GoTasklist className="h-5 w-5" />
                          </div>

                          <div className="">
                            <span
                              onClick={() => onclick?.(task.id)}
                              className="text-ellipsis text-[13px] cursor-pointer block">
                              {getNumberOfWordsFromString(task.name, 5)}
                            </span>
                            <span className="text-gray-600 text-xs block">
                              {moment(task.dueOn).calendar()}
                            </span>
                          </div>
                        </div>
                      );
                    }) : <div className='flex items-center justify-center text-sm text-gray-400'>No Task Found</div>)} 
            </div>
          </TabContent>
        )}
      </div>
    </div>
  );
};

export default TaskListCard;
